import React from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2, Target, ShieldCheck, Crosshair } from 'lucide-react';
import { PlanYourVisitCTA } from '../components/PlanYourVisitCTA';
export function Ammunition() {
  useDocumentMeta('Ammunition in Lake Benton, Minnesota | Kjergaard Sports', 'Large in-store ammunition selection for hunting, target shooting, trap, skeet, waterfowl, upland, turkey, big game, and personal defense at Kjergaard Sports.');
  const categories = ['Hunting ammunition', 'Target shooting ammunition', 'Trap and skeet', 'Waterfowl', 'Upland', 'Turkey', 'Big game', 'Varmint', 'Personal defense', 'Popular calibers'];
  return <div data-id="element-198">
      <PageHero title="Ammunition in Lake Benton, Minnesota" image="https://cdn.magicpatterns.com/uploads/w1nfdCex88kVGKJTVUQepJ/ammunition-wall.jpg" alt="Ammunition and reloading supplies at Kjergaard Sports" data-id="element-199" />

      <section className="py-20 bg-brand-offwhite" data-id="element-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-201">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-202">
            <div className="order-2 lg:order-1" data-id="element-203">
              <img src="https://cdn.magicpatterns.com/uploads/w1nfdCex88kVGKJTVUQepJ/ammunition-wall.jpg" alt="Ammunition selection at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-204" />
            </div>

            <div className="order-1 lg:order-2" data-id="element-205">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-206">
                A Massive In-Store Selection
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-207">
                Whether you are preparing for hunting season, stocking up for a
                weekend at the range, or looking for reliable personal defense
                rounds, Kjergaard Sports maintains a large and diverse inventory
                of ammunition.
              </p>

              <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream mb-8" data-id="element-208">
                <h3 className="font-serif text-xl mb-4" data-id="element-209">
                  We Stock Ammunition For:
                </h3>
                <ul className="grid sm:grid-cols-2 gap-3" data-id="element-210">
                  {categories.map((item, index) => <li key={index} className="flex items-start" data-id="element-211">
                      <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-212" />
                      <span className="text-brand-charcoal/90" data-id="element-213">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="bg-brand-cream border-l-4 border-brand-leather p-6" data-id="element-214">
                <p className="text-brand-charcoal/90 font-medium" data-id="element-215">
                  Call for Current Availability: Inventory changes rapidly.
                  Please call the store for current availability on specific
                  calibers and loads. We do not guarantee specific calibers are
                  always in stock.
                </p>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-216">
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-217">
              <Target className="w-10 h-10 text-brand-hunter mb-4" data-id="element-218" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-219">
                Hunting
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-220">
                From waterfowl and upland bird loads to precision big game
                cartridges, we stock the ammunition hunters rely on in the
                field.
              </p>
            </div>
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-221">
              <Crosshair className="w-10 h-10 text-brand-hunter mb-4" data-id="element-222" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-223">
                Range Use
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-224">
                Target loads for trap and skeet, plinking ammo for a weekend at
                the range, and match-grade options for precision shooters.
              </p>
            </div>
            <div className="bg-brand-cream p-8 rounded-sm border border-brand-bone" data-id="element-225">
              <ShieldCheck className="w-10 h-10 text-brand-hunter mb-4" data-id="element-226" />
              <h3 className="text-xl font-serif text-brand-charcoal mb-3" data-id="element-227">
                Personal Defense
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-228">
                Reliable hollow-point and defensive ammunition designed for
                concealed carry and home protection.
              </p>
            </div>
          </div>

          <div className="bg-brand-bone p-10 rounded-sm border border-brand-cream text-center max-w-4xl mx-auto" data-id="element-229">
            <h3 className="text-2xl font-serif text-brand-charcoal mb-4" data-id="element-230">
              Pair Your Visit with Firearms, Optics & Reloading Supplies
            </h3>
            <p className="text-brand-charcoal/80 leading-relaxed mb-0" data-id="element-231">
              Kjergaard Sports is a complete destination. When you visit to
              stock up on ammunition, you can also browse our massive selection
              of firearms, compare optics, or pick up reloading components for
              your bench.
            </p>
          </div>
        </div>
      </section>

      <PlanYourVisitCTA data-id="element-232" />
    </div>;
}